/* ==========================================
   NAVIGATION
========================================== */

function initNavigation() {

  const header =
    document.querySelector(
      "[data-site-header]"
    );


  if (!header) {
    return;
  }


  /*
    If this exact header is already
    initialized and still connected,
    don't initialize it again.

    This prevents duplicate listeners
    from:
    - immediate initialization
    - DOMContentLoaded
    - Shopify section events
  */

  if (
    window.__siteNavigation &&
    window.__siteNavigation.header === header &&
    header.isConnected
  ) {
    return;
  }


  /*
    If Shopify replaced the old header
    in the Theme Editor, remove every
    listener belonging to the old one.
  */

  if (
    window.__siteNavigation?.controller
  ) {

    window.__siteNavigation
      .controller
      .abort();

  }


  const controller =
    new AbortController();


  const signal =
    controller.signal;


  window.__siteNavigation = {
    header,
    controller
  };


  /* ========================================
     ELEMENTS
  ======================================== */

  const nav =
    header.querySelector(
      ".site-nav"
    );


  const button =
    header.querySelector(
      ".mobile-menu-toggle"
    );


  const hero =
    document.querySelector(
      "[data-home-hero]"
    );


  const heroActions =
    document.querySelector(
      "[data-hero-actions]"
    ) ||
    document.querySelector(
      ".hero-actions"
    );


  /*
    Multiple fallbacks so navigation
    keeps working if the Latest Release
    markup changes slightly later.
  */

  const releaseTarget =
    document.querySelector(
      ".newest-release-eyebrow"
    ) ||
    document.querySelector(
      ".newest-release .page-eyebrow"
    ) ||
    document.querySelector(
      ".newest-release"
    );


  const desktopQuery =
    window.matchMedia(
      "(min-width: 769px)"
    );


  /* ========================================
     STATE
  ======================================== */

  let lastScrollY =
    window.scrollY;


  let ticking =
    false;


  /*
    Desktop hamburger manual override.

    When someone manually changes the
    header state, don't immediately undo
    their choice due to tiny scroll noise.
  */

  let manualState =
    null;


  let manualScrollY =
    window.scrollY;


  /* ========================================
     HELPERS
  ======================================== */

  function isDesktop() {

    return desktopQuery.matches;

  }


  function isHomepage() {

    return Boolean(hero);

  }


  function isMobileMenuOpen() {

    return header.classList.contains(
      "mobile-menu-open"
    );

  }


  /* ========================================
     MOBILE MENU
  ======================================== */

  function closeMobileMenu() {

    header.classList.remove(
      "mobile-menu-open"
    );


    nav?.classList.remove(
      "active"
    );


    button?.classList.remove(
      "active"
    );


    button?.setAttribute(
      "aria-expanded",
      "false"
    );

  }


  function openMobileMenu() {

    header.classList.add(
      "mobile-menu-open"
    );


    nav?.classList.add(
      "active"
    );


    button?.classList.add(
      "active"
    );


    button?.setAttribute(
      "aria-expanded",
      "true"
    );

  }


  function toggleMobileMenu() {

    if (isMobileMenuOpen()) {

      closeMobileMenu();

    } else {

      openMobileMenu();

    }

  }


  /* ========================================
     MANUAL DESKTOP STATE
  ======================================== */

  function clearManualState(
    currentY
  ) {

    if (!manualState) {
      return;
    }


    /*
      Once the visitor intentionally
      scrolls again, hand control back
      to the automatic behavior.
    */

    if (
      Math.abs(
        currentY -
        manualScrollY
      ) > 35
    ) {

      manualState =
        null;

    }

  }


  /* ========================================
     HEADER STATES
  ======================================== */

  function hideHeader() {

    closeMobileMenu();


    header.classList.remove(
      "is-full",
      "is-compact"
    );


    header.classList.add(
      "is-hidden"
    );

  }


  function showFullHeader() {

    closeMobileMenu();


    header.classList.remove(
      "is-hidden",
      "is-compact"
    );


    header.classList.add(
      "is-full"
    );

  }


  function showCompactHeader() {

    closeMobileMenu();


    header.classList.remove(
      "is-hidden",
      "is-full"
    );


    header.classList.add(
      "is-compact"
    );

  }


  /* ========================================
     HOMEPAGE TRIGGERS
  ======================================== */

  function heroButtonsAreGone() {

    if (!heroActions) {
      return true;
    }


    const rect =
      heroActions
        .getBoundingClientRect();


    /*
      Header does not appear until every
      pixel of the hero buttons has moved
      above the viewport.
    */

    return rect.bottom <= 0;

  }


  function releaseReachedHeader() {

    if (!releaseTarget) {
      return false;
    }


    const releaseRect =
      releaseTarget
        .getBoundingClientRect();


    const headerRect =
      header
        .getBoundingClientRect();


    /*
      Keep the full navigation visible
      until Latest Release approaches it.
    */

    return (
      releaseRect.top <=
      headerRect.bottom + 30
    );

  }


  /* ========================================
     DESKTOP UPDATE
  ======================================== */

  function updateDesktop() {

    const currentY =
      window.scrollY;


    const delta =
      currentY -
      lastScrollY;


    clearManualState(
      currentY
    );


    /* ======================================
       MANUAL STATE
    ====================================== */

    if (
      manualState ===
      "compact"
    ) {

      showCompactHeader();


      lastScrollY =
        currentY;


      return;

    }


    if (
      manualState ===
      "full"
    ) {

      showFullHeader();


      lastScrollY =
        currentY;


      return;

    }


    /* ======================================
       HOMEPAGE
    ====================================== */

    if (isHomepage()) {

      /*
        Initial hero:
        completely clean.
      */

      if (!heroButtonsAreGone()) {

        hideHeader();


        lastScrollY =
          currentY;


        return;

      }


      /*
        Hero buttons are gone but Latest
        Release has not reached the header:

        show the full navigation.
      */

      if (!releaseReachedHeader()) {

        showFullHeader();


        lastScrollY =
          currentY;


        return;

      }


      /*
        Latest Release area:

        Scroll down → compact
        Scroll up   → full
      */

      if (delta > 3) {

        showCompactHeader();

      } else if (delta < -3) {

        showFullHeader();

      }


      lastScrollY =
        currentY;


      return;

    }


    /* ======================================
       OTHER DESKTOP PAGES
    ====================================== */

    /*
      Always show the full navigation
      near the top of inner pages.
    */

    if (currentY <= 20) {

      showFullHeader();


      lastScrollY =
        currentY;


      return;

    }


    /*
      Ignore tiny trackpad / wheel noise.
    */

    if (
      Math.abs(delta) < 6
    ) {

      lastScrollY =
        currentY;


      return;

    }


    if (delta > 0) {

      showCompactHeader();

    } else {

      showFullHeader();

    }


    lastScrollY =
      currentY;

  }


  /* ========================================
     MOBILE UPDATE
  ======================================== */

  function updateMobile() {

    const currentY =
      window.scrollY;


    /*
      Homepage hero starts completely
      free of navigation.
    */

    if (
      isHomepage() &&
      !heroButtonsAreGone()
    ) {

      hideHeader();


      lastScrollY =
        currentY;


      return;

    }


    /*
      Once mobile navigation appears,
      it always remains compact.

      Do not change header state while
      the slide-out menu itself is open.
    */

    if (!isMobileMenuOpen()) {

      showCompactHeader();

    }


    lastScrollY =
      currentY;

  }


  /* ========================================
     MAIN UPDATE
  ======================================== */

  function updateNavigation() {

    if (isDesktop()) {

      updateDesktop();

    } else {

      updateMobile();

    }


    ticking =
      false;

  }


  /* ========================================
     SCROLL
  ======================================== */

  function handleScroll() {

    if (ticking) {
      return;
    }


    ticking =
      true;


    requestAnimationFrame(
      updateNavigation
    );

  }


  window.addEventListener(
    "scroll",
    handleScroll,
    {
      passive: true,
      signal
    }
  );


  /* ========================================
     HAMBURGER
  ======================================== */

  button?.addEventListener(
    "click",
    () => {

      /* ====================================
         MOBILE
      ==================================== */

      if (!isDesktop()) {

        toggleMobileMenu();


        return;

      }


      /* ====================================
         DESKTOP

         Hamburger toggles the entire
         navigation between full and compact.
      ==================================== */

      if (
        header.classList.contains(
          "is-full"
        )
      ) {

        manualState =
          "compact";


        manualScrollY =
          window.scrollY;


        showCompactHeader();


        return;

      }


      if (
        header.classList.contains(
          "is-compact"
        )
      ) {

        manualState =
          "full";


        manualScrollY =
          window.scrollY;


        showFullHeader();

      }

    },
    {
      signal
    }
  );


  /* ========================================
     MOBILE NAVIGATION LINKS
  ======================================== */

  nav
    ?.querySelectorAll("a")
    .forEach(
      (link) => {

        link.addEventListener(
          "click",
          () => {

            if (!isDesktop()) {

              closeMobileMenu();

            }

          },
          {
            signal
          }
        );

      }
    );


  /* ========================================
     ESCAPE KEY
  ======================================== */

  document.addEventListener(
    "keydown",
    (event) => {

      if (
        event.key !== "Escape"
      ) {
        return;
      }


      if (
        !isDesktop() &&
        isMobileMenuOpen()
      ) {

        closeMobileMenu();


        button?.focus();

      }

    },
    {
      signal
    }
  );


  /* ========================================
     BREAKPOINT CHANGE
  ======================================== */

  desktopQuery.addEventListener(
    "change",
    () => {

      closeMobileMenu();


      manualState =
        null;


      lastScrollY =
        window.scrollY;


      updateNavigation();

    },
    {
      signal
    }
  );


  /* ========================================
     INITIAL STATE
  ======================================== */

  updateNavigation();

}


/* ==========================================
   PAGE LOAD
========================================== */

document.addEventListener(
  "DOMContentLoaded",
  initNavigation
);


/* ==========================================
   SHOPIFY THEME EDITOR
========================================== */

document.addEventListener(
  "shopify:section:load",
  initNavigation
);


/*
  Also initialize immediately in case
  navigation.js loads after DOMContentLoaded.
*/

initNavigation();